const SALE_CAMPAIGNS = {
  feirao: /feir[aã]o/i,
  corujao: /coruj[aã]o/i,
  cashback: /Cashback/i,
  blackout: /(\b)blackout(\b)/i,
  blackoutDay: /blackoutDay/i,
}

const hasFirstActiveCampaign = () => {
  return (
    process.env.REACT_APP_CAMPAIGN &&
    new Date() < new Date(process.env.REACT_APP_CAMPAIGN_END_DATE) &&
    new Date() >= new Date(process.env.REACT_APP_CAMPAIGN_START_DATE)
  )
}

const hasSecondActiveCampaign = () => {
  return (
    process.env.REACT_APP_SECOND_CAMPAIGN &&
    new Date() < new Date(process.env.REACT_APP_SECOND_CAMPAIGN_END_DATE) &&
    new Date() >= new Date(process.env.REACT_APP_SECOND_CAMPAIGN_START_DATE)
  )
}

const hasActiveCampaign = () => {
  return hasFirstActiveCampaign() || hasSecondActiveCampaign()
}

const isAnActiveCampaign = campaign => {
  return (
    (hasSecondActiveCampaign() &&
      campaign.test(process.env.REACT_APP_SECOND_CAMPAIGN)) ||
    (hasFirstActiveCampaign() && campaign.test(process.env.REACT_APP_CAMPAIGN))
  )
}

const campaignConfigurations = campaign => {
  const campaigns = {
    Feirão: {
      filter: false,
      banner: true,
      countDown: false,
    },
    Corujão: {
      filter: true,
      banner: false,
      countDown: false,
    },
    Cashback: {
      filter: true,
      banner: true,
      countDown: false,
    },
    Blackout: {
      filter: true,
      banner: true,
      countDown: false,
    },
    BlackoutDay: {
      filter: true,
      banner: true,
      countDown: false,
      countDownOnProperty: true,
    },
  }

  return campaigns[campaign]
}

const isCampaignProperty = tags => {
  const campaigns = Object.values({ ...SALE_CAMPAIGNS })

  const isCampaign = campaigns.map(campaign => {
    const hasCampaignOnTags = tags.some(tag => campaign.test(tag))

    return hasCampaignOnTags
  })

  return isCampaign.some(bool => bool)
}

const timerFirstCampaign = () => {
  const startDate = new Date(process.env.REACT_APP_CAMPAIGN_START_DATE)
  const endDate = new Date(process.env.REACT_APP_CAMPAIGN_END_DATE)

  if (new Date() < startDate) {
    return process.env.REACT_APP_CAMPAIGN_START_DATE
  }

  if (new Date() < endDate && new Date() > startDate) {
    return process.env.REACT_APP_CAMPAIGN_END_DATE
  }

  return ''
}

const timerSecondCampaign = () => {
  const startDate = new Date(process.env.REACT_APP_SECOND_CAMPAIGN_START_DATE)
  const endDate = new Date(process.env.REACT_APP_SECOND_CAMPAIGN_END_DATE)

  if (new Date() < startDate) {
    return process.env.REACT_APP_SECOND_CAMPAIGN_START_DATE
  }

  if (new Date() < endDate && new Date() > startDate) {
    return process.env.REACT_APP_SECOND_CAMPAIGN_END_DATE
  }

  return ''
}

const isPreLaunch = () => {
  if (new Date() < new Date(process.env.REACT_APP_CAMPAIGN_START_DATE)) {
    return true
  }
  return false
}

const replaceCampaignToShow = enviriomentVariable => {
  if (SALE_CAMPAIGNS.feirao.test(enviriomentVariable)) {
    return 'Feirão'
  }

  if (SALE_CAMPAIGNS.blackoutDay.test(enviriomentVariable)) {
    return 'Blackout Day'
  }

  return enviriomentVariable
}

const activeCountDownToFirstCampaign =
  hasFirstActiveCampaign() &&
  campaignConfigurations(process.env.REACT_APP_CAMPAIGN) &&
  campaignConfigurations(process.env.REACT_APP_CAMPAIGN).countDown &&
  timerFirstCampaign()

const activeCountDownToSecondCampaign =
  hasSecondActiveCampaign() &&
  campaignConfigurations(process.env.REACT_APP_SECOND_CAMPAIGN) &&
  campaignConfigurations(process.env.REACT_APP_SECOND_CAMPAIGN).countDown &&
  timerSecondCampaign()

const activeCountDownPropertyToFirstCampaign =
  hasFirstActiveCampaign() &&
  campaignConfigurations(process.env.REACT_APP_CAMPAIGN) &&
  campaignConfigurations(process.env.REACT_APP_CAMPAIGN).countDownOnProperty &&
  timerFirstCampaign()

const activeCountDownPropertyToSecondCampaign =
  hasSecondActiveCampaign() &&
  campaignConfigurations(process.env.REACT_APP_SECOND_CAMPAIGN) &&
  campaignConfigurations(process.env.REACT_APP_SECOND_CAMPAIGN)
    .countDownOnProperty &&
  timerSecondCampaign()

export {
  SALE_CAMPAIGNS,
  isCampaignProperty,
  timerFirstCampaign,
  timerSecondCampaign,
  isPreLaunch,
  isAnActiveCampaign,
  hasActiveCampaign,
  hasFirstActiveCampaign,
  hasSecondActiveCampaign,
  campaignConfigurations,
  replaceCampaignToShow,
  activeCountDownToFirstCampaign,
  activeCountDownToSecondCampaign,
  activeCountDownPropertyToFirstCampaign,
  activeCountDownPropertyToSecondCampaign,
}
